import React, { useState } from "react";
import { CardWithActions, LineDivider } from "@/components";
import { AppBar, Box } from "@mui/material";
import { TabbedNavigationWithBadges } from "@/components";
import RegularizeCalendar from "./RegularizationCalender";
import HistoryRegularize from "./HistoryRegularize";
import PendingRegularize from "./PendingRegularize";
import { count } from "d3";
import { useGetEmployeeRegularizationQuery } from "@/api/services/attendance/regularization/EmployeeRegularization";


const Regularization = () => {
  const [tabIndex, setTabIndex] = useState(0);

  // Fetch data for "Pending" and "History"
  const { data: pendingData, refetch, isLoading: isLoadingPending  } = useGetEmployeeRegularizationQuery({ key: "Pending" });
  const { data: historyData, refetch: refetchHistory, isLoading: isLoadingHistory } = useGetEmployeeRegularizationQuery({ key: "Approved" });

  // Compute records
  const pendingRecords = pendingData || [];
  const historyRecords = historyData || [];

  // Tabs with dynamic count
  const tabs = [
    { name: "Apply", count: 0, key: "apply" },
    { name: "Pending", count: pendingRecords?.data?.count, key: "Pending" },
    { name: "Completed", count: historyRecords?.data?.count, key: "Approved" },
  ];

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };
  const renderContent = (
    <Box sx={{ p: (theme) => theme.spacing(0, 0) }}>
      {tabIndex === 0 && (
        <>
          <LineDivider />
          <RegularizeCalendar pendingRecords={pendingRecords}/>
        </>
      )}
      {tabIndex === 1 && (
        <>
          <LineDivider />
          <PendingRegularize regularizationRecords={pendingRecords} refetch={refetch} refetchHistory={refetchHistory} isLoadingPending={isLoadingPending} tabName="Pending"/>
        </>
      )}
      {tabIndex === 2 && (
        <>
          <LineDivider />
          <HistoryRegularize regularizationRecords={historyRecords} refetchHistory={refetchHistory} isLoadingHistory={isLoadingHistory} />
        </>
      )}
    </Box>
  );

  return (
    <CardWithActions headerTitle="Regularization" headerActions={[]}>
      <TabbedNavigationWithBadges
        tabs={tabs}
        value={tabIndex}
        onChange={handleTabChange}
        renderContent={renderContent}
      />
    </CardWithActions>
  );
};

export default Regularization;
